import { render, staticRenderFns } from "./dress-code.vue?vue&type=template&id=01d158f6"
import script from "./dress-code.vue?vue&type=script&lang=js"
export * from "./dress-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports